import React, { useState } from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { Mobile, Landscape } from "../Response";

const Message = () => {
  const back = useSelector((state) => state.switch.back);
  const [email, setEmail] = useState("");
  const [Message, setMessage] = useState("");
  const URL = process.env.REACT_APP_API_URL;
  const handelSubmit = async (e) => {
    e.preventDefault();
    if (email && Message) {
      try {
        const res = await fetch(`${URL}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email, Message }),
        });
      } catch (er) {}
    }
    setEmail("");
    setMessage("");
  };

  return (
    <Container back={back}>
      <Wrap>
        <Left>
          <TitleMessg back={back}>You can text me</TitleMessg>
          <Desc back={back}>If you have any question or anything for me</Desc>
          <Speech back={back}>
            I will be glad to see that you might have something for me so you
            can text me if you have any question or anything that you want to
            tell me, feel free to send it to me
            <br />I will text you back
          </Speech>
        </Left>
        <Right onSubmit={handelSubmit}>
          <InpCon>
            <Input
              required
              type="email"
              value={email}
              placeholder="YourEmail@gmail.com"
              onChange={(e) => setEmail(e.target.value)}
              back={back}
            />
            <Lable>Your Email</Lable>
          </InpCon>
          <TextMessage
            required
            value={Message}
            placeholder="Write something.."
            className="las"
            onChange={(e) => setMessage(e.target.value)}
            back={back}
          />
          <ButtonCon>
            <Button
              back={back}
              disabled={email == null || Message == null}
              dis={email == null || Message == null}
            >
              Send
            </Button>
          </ButtonCon>
        </Right>
      </Wrap>
    </Container>
  );
};
export default Message;
const Container = styled.div`
  max-width: 100%;
  height: 100vh;

  background: ${(props) =>
    props.back === "sun" ? " rgb(239, 245, 248)" : "rgb(22, 28, 35,0.3)"};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 100px;
  ${Mobile({ marginTop: 20 })}
  ${Landscape({ margin: "30px 0px 0px 0px", height: "100vh", width: "100%" })}
`;

const Wrap = styled.div`
  // background: #f7f9fc;
  width: 86%;
  height: 85%;
  display: flex;
  // flex-direction: column;

  justify-content: center;
  align-items: center;
  gap: 80px;

  padding: 40px;
  ${Mobile({
    width: "97%",
    height: "97%",
    // overflow: "hidden",
    padding: 10,
    gap: 40,
    flexDirection: "column",
  })}
  ${Landscape({ height: "98%", width: "97%", gap: 20, padding: "10px 5px" })}
`;
const Left = styled.div`
  flex: 1.2;
  height: 100%;
  // background: #0c0c1c;
  // background: #f7f9fc;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  ${Mobile({ flex: 1, width: "100%", alignItems: "center" })}
  ${Landscape({ flex: 1, height: "100%" })}
`;
const TitleMessg = styled.p`
  color: ${(props) =>
    props.back === "sun"
      ? "rgba(12, 12, 28, 0.75)"
      : " rgba(228, 236, 240, 0.7)"};
  // color: rgb(20, 20, 26);
  font-size: 40px;
  font-weight: 500;
  ${Mobile({ fontSize: 20, fontWeight: 600 })}
  ${Landscape({ fontSize: 22, fontWeight: 700, marginLeft: 10 })}
`;
const Desc = styled.h1`
  color: ${(props) =>
    props.back === "sun" ? "rgba(12, 12, 28, 0.9)" : " rgba(228, 236, 240)"};
  margin-top: 30px;
  margin-bottom: 40px;
  font-size: 50px;
  line-height: 1.2;
  ${Mobile({ margin: 13, fontSize: 23, textAlign: "center", fontWeight: 700 })}
  ${Landscape({ fontSize: 30, fontWeight: 800, margin: 10 })}
`;
const Speech = styled.p`
  color: ${(props) =>
    props.back === "sun"
      ? "rgba(12, 12, 28, 0.5)"
      : " rgba(228, 236, 240, 0.5)"};
  font-size: 22px;
  font-weight: 400;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  ${Mobile({ fontSize: 16, fontWeight: 500, textAlign: "center" })}
  ${Landscape({ fontSize: 18, fontWeight: 500 })}
`;
const Right = styled.form`
  flex: 1.2;
  width: 95%;
  height: 80%;
  // background: green;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // padding: 30px;
  ${Mobile({ flex: 1, width: "100%", alignItems: "center" })}
  ${Landscape({ flex: 1, height: "100%", alignItems: "center" })}
`;

const InpCon = styled.div`
  width: 90%;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 30px;
  // ${Mobile({ flex: 0.6, marginBottom: 6 })}
`;
const Input = styled.input`
  width: 60%;
  // height: 40%;
  border-radius: 10px;
  padding: 15px 10px;
  border: none;
  color: ${(props) =>
    props.back === "sun"
      ? "rgba(12, 12, 28, 0.5)"
      : " rgba(228, 236, 240, 0.7)"};
  background: ${(props) =>
    props.back === "sun"
      ? "  rgba(226, 232, 235, 0.6)"
      : "rgb(22, 28, 35,0.5)"};
  border: 3px solid rgb(151, 151, 151, 0.1);
  ${Mobile({
    width: "75%",
    padding: "10px 10px",
    fontSize: 12,
    border: "1px solid rgb(151, 151, 151, 0.1)",
  })}
  ${Landscape({
    width: "75%",
    padding: "10px 10px",
    fontSize: 14,
    border: "1px solid rgb(151, 151, 151, 0.1)",
  })}
`;
const Lable = styled.h3`
  font-size: 24px;
  color: rgba(12, 12, 28, 0.5);
  ${Mobile({ display: "none" })}
  ${Landscape({ display: "none" })}
`;
const TextMessage = styled.textarea`
  // background: rgba(8, 87, 65, 0.051);
  max-width: 90%;
  min-width: 90%;
  min-height: 30%;
  max-height: 70%;
  // width: 500px;
  font-size: 16px;
  border: none;
  flex: 1.5;
  // margin: 50px 20px;
  border-radius: 20px;
  padding: 20px;
  background: ;
  background: ${(props) =>
    props.back === "sun" ? " rgba(219, 226, 230, 0.914)" : "rgb(22, 28, 35)"};
  color: ${(props) =>
    props.back === "sun"
      ? "rgba(12, 12, 28, 0.5)"
      : " rgba(228, 236, 240, 0.7)"};
  ${Mobile({ fontSize: 14, borderRadius: 10, padding: 15 })}
  ${Landscape({ fontSize: 14, borderRadius: 8, padding: 15 })}
`;
const ButtonCon = styled.div`
  width: 100%;
  flex: 1;

  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  ${Mobile({ margin: 0 })}
  ${Landscape({ margin: 0 })}
`;
const Button = styled.button`
  width: 40%;
  height: 50%;
  border: none;
  cursor: pointer;
  font-weight: 600;
  border-radius: 20px;
  color: white;
  border: ${(props) =>
    props.back !== "sun" && "1px solid rgba(143, 166, 168, 0.15)"};
  background: ${(props) =>
    props.back === "sun" ? "rgba(12, 12, 28,0.9)" : "rgba(26, 32, 39,1)"};

  background: ${(props) => props.dis && "rgba(26, 32, 39,0.5)"};

  color: ${(props) =>
    props.back === "sun" ? " white" : "rgba(244, 251, 255, 0.7)"};

  font-size: 26px;
  color: ${(props) =>
    props.dis && props.back === "sun" ? "rgb(236, 242, 244,0.7)" : "white"};
  color: ${(props) =>
    props.dis && props.back !== "sun"
      ? "rgb(236, 242, 244,0.7)"
      : "rgb(236, 242, 244,0.9)"};

  ${Mobile({
    width: "90%",
    borderRadius: 10,
    fontSize: 20,
    letterSpacing: 1.2,
  })}
  ${Landscape({
    width: "50%",
    height: "60%",
    borderRadius: 10,
    letterSpacing: 1.1,
    fontSize: 24,
  })}
`;
